import React from 'react';
import styles from './style.css';
import youllLogo from './images/youllHeader.png';

const Youll = () => (
  <div className={styles.youll__container}>
    <div className={styles.linear__gradient} />
    <div className={styles.youll__text}>
      <div className={styles.youll__title}>
        <span>Empower and inspire</span> the world with what you know.
      </div>

      <div className={styles.youll__subtitle}>
        No-code iOS and Android app to teach others what you know.
      </div>
    </div>

    <div className={styles.youll__logo__container}>
      <img src={youllLogo} alt="youll logo" className={styles.youll__logo} />
    </div>
    <div className={styles.head__title}>
      No-code iOS and Android app to teach others what you know.
    </div>
  </div>
);

export default Youll;
